<template>
   <div class="formButtonSubmit">
      <button
         class="loginbtn primaryBtn"
         :disabled="disabled || loading"
         @click="handleClick"
         >
      <span v-if="loading" class="loader"></span>
      <span v-else>{{ buttonText }}</span>
      </button>
   </div>
</template>
<script>
export default {
  props: {
    // Propiedad para el texto del botón
    buttonText: {
      type: String,
      default: 'Cargar Información', // Texto predeterminado
    },
  },
  methods: {
    // Método que emite un evento al hacer clic en el botón
    handleClick () {
      this.$emit('click')
    },
  },
}
</script>